export default __webpack_public_path__ + "media/zurb/img/home/Netflix-7f41266586f6432e94103bed2c67a3d6.svg";